// extracted by mini-css-extract-plugin
module.exports = {"recovery":"recovery-pass-btn_recovery__GBuBX"};